export const teams = [
    {
        name: 'Ajay Kumar Srivastava',
        desg: 'State Spokesperson',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815226/AjayKumarSrivastava_knqy1n.jpg'   
    },
    {
        name: 'Anil Dutt Chaturvedi',
        desg: 'Member',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815227/AnilDuttChaturvedi_sb3heu.jpg'
    },
    {
        name: 'Ram Kripal Chaudhary',
        desg: 'State Media Handler',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815228/RamKripalChaudhary_ge5vcs.jpg'
    },
    {
        name: 'Gopal Das Srivastava',
        desg: 'State Media Handler',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815228/GopalDasSrivastava_losrid.jpg'
    },
    {
        name: 'Ghanshyam Bhatt',
        desg: 'Member',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815227/GhanshyamBhatt_jrjiw2.jpg'
    },
    {
        name: 'Rashmi Tripathi',
        desg: 'Member',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815229/RashmiTripathi_vq9ydi.jpg'
    },
    {
        name: 'Dinesh Singh',
        desg: 'Member',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815226/DineshKumarSingh_exf7ph.jpg'
    },
    {
        name: 'Krishna Kumar Upadhyay',
        desg: 'Member',
        img: 'https://res.cloudinary.com/dkvuuyi2k/image/upload/v1730815227/KrishnaKumarUpadhyay_ukj2le.jpg'
    }
]